import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from './Auth';
import Login from './Login';

const LoginPage = () => {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  // If user is already authenticated, redirect to the main app
  useEffect(() => {
    if (user) {
      navigate('/chat');
    }
  }, [user, navigate]);

  // If user is authenticated, don't render the login form
  if (user) {
    return null;
  }

  return <Login />;
};

export default LoginPage;
